<template>
  <article
    v-if="currentPage && currentPage.protection.locked === false"
    class="archive-events single-page"
    id="events-page"
  >
    <PageHeader />
    <FilteredPostsList
      taxonomy="event_cat"
      postType="events"
      filters
      key="event_cat"
    />
  </article>
  <PassProtected
    v-else-if="currentPage && currentPage.protection.locked === true"
  >
  </PassProtected>
</template>

<script>
import FilteredPostsList from "@/components/blocks/FilteredPostsList";

export default {
  name: "archive-events",
  components: {
    FilteredPostsList
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {}
};
</script>

<style lang="scss">
@import "./../assets/scss/mixins.scss";
@import "./../assets/scss/vars.scss";

.archive-events {
  .single-event-block {
    @include mquery(767px) {
      max-width: 100%;
      width: 100%;
    }
    .event-footer {
      .column {
        max-width: 50%;
        width: 100%;
        padding: 20px;
      }
    }
    .event-block-link {
      display: flex;
      flex-direction: column;
      position: relative;
      justify-content: space-between;
      height: 100%;
      background: rgba(42, 46, 52, 1);
      padding-bottom: 0;
      text-decoration: none;
      transition: box-shadow 0.12s ease-in-out;
      &:hover {
        box-shadow: 0 0 10px 0 rgba(74, 79, 85, 0.5);
      }
      .event-thumb {
        padding-bottom: 56.25%;
        position: relative;
        .bg-image {
          padding-bottom: 56.25%;
        }
      }
      .event-footer {
        display: flex;
        position: relative;
        .left {
          max-width: 50%;
        }
        .right {
          display: flex;
          justify-content: flex-end;
          align-items: flex-end;
          max-width: 50%;
        }
      }
    }
  }
}
</style>
